"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index219.js");var n=e.engineUserAgent,t=/web0s(?!.*chrome)/i.test(n);exports.engineIsWebosWebkit=t;
